import { motion } from "framer-motion";
import { Bath, BedDouble, BedSingle, Building2, Car, Users } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = [Users, BedDouble, BedSingle, Bath, Building2, Car];

export default function Apartment() {
  const { t } = useLanguage();

  return (
    <section id="appartamento" data-testid="apartment-section" className="py-20 lg:py-28">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE }}
              className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-terracotta font-bold mb-4"
            >
              {t.apartment.overline}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink leading-tight text-balance"
            >
              {t.apartment.title}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
              className="mt-6 text-sm sm:text-base leading-relaxed text-clay"
            >
              {t.apartment.body}
            </motion.p>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 sm:gap-5">
          {t.apartment.specs.map((spec, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={spec.title}
                data-testid={`spec-card-${i}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 2) * 0.12 + Math.floor(i / 2) * 0.06, ease: EASE }}
                whileHover={{ y: -6 }}
                className="rounded-2xl bg-white border border-[#E2DCD5] p-6 sm:p-7 shadow-sm hover:shadow-xl hover:shadow-ink/5 hover:border-terracotta/40 transition-shadow duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-sand flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-terracotta" />
                </div>
                <h3 className="font-serif text-xl sm:text-2xl font-semibold text-ink">{spec.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-clay">{spec.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
